import React, { useEffect, useState } from 'react';
import { Icons } from "../Icons/Icons";
import { getUserData, signOut } from "../../api/authService";
import HeaderImage from "./Assets/header-img.png";
import ContactPopup from '../Popups/ContactPopup';
import ProfilePopup from '../Popups/ProfilePopup';
import "./Header.scss";

interface UserData {
  fullName: string;
  email: string;
}

export const Header = () => {
  const [isContactPopupOpen, setContactPopupOpen] = useState(false);
  const [isProfilePopupOpen, setProfilePopupOpen] = useState(false);
  const [userData, setUserData] = useState<UserData | null>(null);

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.href = "/sign-in";
    } catch (error) {
      console.error("Error during sign out: ", error);
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getUserData();
        setUserData(data);
        if (data && data.fullName) {
          localStorage.setItem('username', data.fullName);
        }
      } catch (error) {
        console.error("Error getting user data: ", error);
      }
    };
    fetchUserData();
  }, []);

  const handleContactClick = () => {
    setContactPopupOpen(true);
  };

  const handleProfileClick = () => {
    setProfilePopupOpen(true);
  };

  const handleContactSubmit = (message: string) => {
    console.log("Message submitted: ", message);
  }

  const handleResetPassword = async () => {
    try {
      await signOut();
      window.location.href = "/reset-password";
    } catch (error) {
      console.error("Error during sign out: ", error);
    }
  };

  return (
    <>
      <header className="header">
        <img src={HeaderImage} alt="header-image" />
        <div className="wrap">
          <div className="logo">{Icons.WhiteLogoIcon}</div>
          <nav className="nav">
            <button className="nav-button" onClick={handleContactClick}>Contact us</button>
            <button className="nav-button" onClick={handleProfileClick}>Profile</button>
            <button className="nav-button" onClick={handleSignOut}>Log Out</button>
          </nav>
        </div>
      </header>
      <ContactPopup
        isOpen={isContactPopupOpen}
        onClose={() => setContactPopupOpen(false)}
        onSubmit={handleContactSubmit}
      />
      <ProfilePopup
        isOpen={isProfilePopupOpen}
        onClose={() => setProfilePopupOpen(false)}
        name={userData?.fullName || ''}
        email={userData?.email || ''}
        onResetPassword={handleResetPassword}
      />
    </>
  );
};